import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { removeFromCompare, clearCompare } from '../../store/slices/compareSlice';
import CloseIcon from '@mui/icons-material/Close';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import './ComparePage.css';

const BASE = process.env.REACT_APP_API_BASE_URL;

export default function CompareBar() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cars } = useSelector(s => s.compare);

  if (cars.length === 0) return null;

  return (
    <div className="comp-float-bar">
      <div className="comp-float-cars">
        <span className="comp-float-count">{t('carsCountLabel', { count: cars.length })}</span>
        {cars.map(car => (
          <div key={car.id} className="comp-float-car">
            <div className="comp-float-img-wrap">
              <img
                src={car.image ? `${BASE}/car-images/${car.image}` : '/placeholder-car.png'}
                alt=""
                onError={e => { e.target.src = '/placeholder-car.png'; }}
              />
              {car.status === 'Vendu' && <span className="comp-float-sold-dot" title={t('soldBadge')} />}
            </div>
            <span>{car.brandName || car.brand} {car.modelName || car.model}</span>
            <button className="comp-float-remove" onClick={() => dispatch(removeFromCompare(car.id))}>
              <CloseIcon sx={{ fontSize: 14 }} />
            </button>
          </div>
        ))}
      </div>
      <button className="comp-float-btn" onClick={() => navigate('/comparer')}>
        <CompareArrowsIcon sx={{ fontSize: 18, mr: 0.5 }} /> {t('compareBtn')}
      </button>
    </div>
  );
}
